import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import formatNumber, { convertNumberToWordsInFCFA, formatDateWithTime } from '../../../utils/functions';
import { APP_NAME } from '../../../utils';

const parseEmecef = (raw) => {
  if (!raw) return null;
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
  } catch {
    return null;
  }
};

export default function Invoice({ data }) {
  const emecef = parseEmecef(data?.emecef_data);
  const items = Array.isArray(data?.items) ? data.items : [];

  return (
    <div className="invoice-copy relative">
      <div className="flex flex-row justify-between items-start mt-10">
        <div>
          <img src="/assets/img/logo_v2.png" height={100} width={100} alt={APP_NAME} />
          <p className="font-medium text-sm mt-3">C/1775 C, QUARTIER GBEDJEKOME - OUEDO</p>
          <p className="font-medium text-sm">IFU 3202434985932</p>
          <p className="font-medium text-sm">info@asebat.com</p>
          <p className="font-medium text-sm">+229 01 61 89 89 00</p>
        </div>
        {emecef?.codeMECeFDGI && !emecef.errors && (
          <div>
            <p className="mb-0 font-semibold text-[10px]">ÉLÉMENTS DE SÉCURITÉ DE LA FACTURE NORMALISÉE</p>
            <table className="border-collapse w-full text-sm">
              <tbody>
                <tr>
                  <td className="p-1 border" rowSpan={4}>
                    <QRCodeCanvas value={emecef.qrCode || ''} size={80} />
                  </td>
                  <td className="p-1 border text-[10px]">Code MECeF/DGI:</td>
                  <td className="p-1 border text-[10px]">{emecef.codeMECeFDGI}</td>
                </tr>
                <tr>
                  <td className="p-1 border text-[10px]">MECeF NIM:</td>
                  <td className="p-1 border text-[10px]">{emecef.nim}</td>
                </tr>
                <tr>
                  <td className="p-1 border text-[10px]">MECeF Compteurs:</td>
                  <td className="p-1 border text-[10px]">{emecef.counters}</td>
                </tr>
                <tr>
                  <td className="p-1 border text-[10px]">MECeF Heure:</td>
                  <td className="p-1 border text-[10px]">{emecef.dateTime}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
      <p className="font-medium text-sm mt-3">
        <span className="font-semibold">Client</span> : {data?.customer?.name || '—'}
        {' · '}
        <span className="font-semibold">Date</span> : {formatDateWithTime(data?.created_at)}
      </p>
      <p className="text-right mt-2 font-bold uppercase">Facture de vente — articles cassés / gâtés</p>
      <table className="border-collapse mt-3 w-full text-sm">
        <thead>
          <tr>
            <th className="p-2 border">Produit</th>
            <th className="p-2 border">Prix</th>
            <th className="p-2 border">Qté</th>
            <th className="p-2 border">Total</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td className="p-2 border">{item.name}</td>
              <td className="p-2 border">{formatNumber(item.unit_price)} FCFA</td>
              <td className="p-2 border">{item.quantity} {item.unit || ''}</td>
              <td className="p-2 border">{formatNumber(item.total_price)} FCFA</td>
            </tr>
          ))}
          <tr>
            <td colSpan={3} className="p-2 border text-end"><b>Montant HT</b></td>
            <td className="p-2 border">{formatNumber(data?.montant_ht)} FCFA</td>
          </tr>
          <tr>
            <td colSpan={3} className="p-2 border text-end"><b>TVA</b></td>
            <td className="p-2 border">{formatNumber(data?.tva)} FCFA</td>
          </tr>
          {Number(data?.discount) > 0 && (
            <tr>
              <td colSpan={3} className="p-2 border text-end"><b>Remise</b></td>
              <td className="p-2 border">−{formatNumber(data.discount)} FCFA</td>
            </tr>
          )}
          <tr>
            <td colSpan={3} className="p-2 border text-end"><b>NET</b></td>
            <td className="p-2 border">{formatNumber(data?.montant_net)} FCFA</td>
          </tr>
        </tbody>
      </table>
      <p className="font-medium text-sm mt-3 capitalize">
        <span className="font-bold">Montant en lettre</span> : {convertNumberToWordsInFCFA(Math.round(data?.montant_net || 0))}
      </p>
    </div>
  );
}
